const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL = process.env.NODE_ENV === "production" ? "" : CONFIGURED_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const request = async (token, options = {}) => {
  const response = await fetch(`${API}/rooms/spatial-layout`, {
    credentials: "include",
    headers: {
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...options,
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body.detail || `Request failed: ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return body;
};

export const getSpatialHomeLayout = async (token) => request(token);
export const saveSpatialHomeLayout = async (layout, token) => request(token, {
  method: "PUT",
  body: JSON.stringify(layout),
});
